import { useQuery } from '@tanstack/react-query';
import { screener, ScreenerFilterOption } from '@toggle/toggle';
import { ChangeEvent, useEffect, useRef, useState } from 'react';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export const useDebounce = (value: string, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const SCREENER_FILTER_SEARCH = 'SCREENER_FILTER_SEARCH';

export const useFilterOptionSearch = (
  filter: string,
  defaultOptions: ScreenerFilterOption[]
) => {
  const [value, setValue] = useState('');
  const debouncedSearchTerm = useDebounce(value, 300);
  const prevData = useRef(defaultOptions);

  const { data } = useQuery({
    queryKey: [SCREENER_FILTER_SEARCH, filter, debouncedSearchTerm],
    queryFn: () =>
      wretchRequest<ScreenerFilterOption[]>(
        screener.getFilterOptions.path(filter, debouncedSearchTerm)
      ),
    initialData: prevData.current,
    enabled: !!debouncedSearchTerm,
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleTextChange = (value: string) => {
    setValue(value);
  };

  const onClear = () => {
    setValue('');
  };

  prevData.current = data;

  return { value, data, handleChange, onClear, handleTextChange };
};
